import { IconSvgProps } from "@modules/ui/components/huButtonIcon"

/**
 * Icon for BoxStaffOwner, it's an icon with two keys
 * @param props
 * @returns
 */
export const BoxStaffOwnerIcon: React.FC<IconSvgProps> = (props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_12814_49643"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="9"
      y="8"
      width="21"
      height="32"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6981 22.9484C24.7535 23.2962 27.8242 21.6956 29.2075 18.7591C30.9441 15.0724 29.3632 10.6759 25.6764 8.93931C21.9897 7.20271 17.5932 8.78362 15.8566 12.4704C14.5422 15.2608 15.1283 18.4579 17.0896 20.6005L9.80779 36.0595L11.6815 39.4222L14.8719 38.4449L15.1487 35.9872L16.8778 34.1865L16.611 32.1558L18.3779 31.0019L18.5384 28.0641L20.8896 25.6696L20.6668 24.2725L21.6981 22.9484ZM25.4135 13.7066C24.9914 14.6028 23.9226 14.9871 23.0264 14.565C22.1302 14.1428 21.7459 13.0741 22.168 12.1779C22.5902 11.2817 23.6589 10.8974 24.5551 11.3195C25.4514 11.7417 25.8357 12.8104 25.4135 13.7066Z"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask0_12814_49643)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6981 22.9484C24.7535 23.2962 27.8242 21.6956 29.2075 18.7591C30.9441 15.0724 29.3632 10.6759 25.6764 8.93931C21.9897 7.20271 17.5932 8.78362 15.8566 12.4704C14.5422 15.2608 15.1283 18.4579 17.0896 20.6005L9.80779 36.0595L11.6815 39.4222L14.8719 38.4449L15.1487 35.9872L16.8778 34.1865L16.611 32.1558L18.3779 31.0019L18.5384 28.0641L20.8896 25.6696L20.6668 24.2725L21.6981 22.9484ZM25.4135 13.7066C24.9914 14.6028 23.9226 14.9871 23.0264 14.565C22.1302 14.1428 21.7459 13.0741 22.168 12.1779C22.5902 11.2817 23.6589 10.8974 24.5551 11.3195C25.4514 11.7417 25.8357 12.8104 25.4135 13.7066Z"
        fill="#3B3184"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.912 22.6789C23.9674 23.0266 27.0381 21.4261 28.4213 18.4896C30.1579 14.8029 28.577 10.4064 24.8903 8.66978C21.2035 6.93318 16.8071 8.51408 15.0705 12.2008C13.756 14.9913 14.3422 18.1884 16.3035 20.3309L9.02166 35.79L10.8954 39.1527L14.0858 38.1754L14.3626 35.7177L16.0917 33.9169L15.8249 31.8863L17.5917 30.7324L17.7523 27.7945L20.1035 25.4L19.8807 24.0029L20.912 22.6789ZM24.6274 13.4371C24.2052 14.3333 23.1365 14.7176 22.2403 14.2955C21.3441 13.8733 20.9598 12.8046 21.3819 11.9084C21.8041 11.0122 22.8728 10.6279 23.769 11.05C24.6652 11.4722 25.0495 12.5409 24.6274 13.4371Z"
        fill="#6450F7"
      />
      <rect
        x="17.6416"
        y="21.9336"
        width="0.709625"
        height="15.2184"
        transform="rotate(26.0553 17.6416 21.9336)"
        fill="#3B3184"
      />
    </g>
    <mask
      id="mask1_12814_49643"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="24"
      y="4"
      width="15"
      height="35"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.5108 19.0339C37.3292 17.8038 39.1845 14.8799 38.91 11.6456C38.5654 7.58492 34.9942 4.57245 30.9336 4.91705C26.8729 5.26166 23.8604 8.83284 24.205 12.8935C24.4658 15.967 26.5751 18.44 29.3461 19.3113L30.791 36.3384L34.0976 38.3094L36.3688 35.865L35.3768 33.5995L35.9708 31.1746L34.7223 29.551L35.6731 27.6671L34.3399 25.0443L35.1747 21.7939L34.2818 20.6965L34.5108 19.0339ZM33.095 9.17438C33.1787 10.1615 32.4464 11.0296 31.4593 11.1134C30.4722 11.1971 29.6041 10.4648 29.5203 9.47774C29.4366 8.49063 30.1689 7.62251 31.156 7.53874C32.1431 7.45497 33.0112 8.18727 33.095 9.17438Z"
        fill="#6450F7"
      />
    </mask>
    <g mask="url(#mask1_12814_49643)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.5108 19.0339C37.3292 17.8038 39.1845 14.8799 38.91 11.6456C38.5654 7.58492 34.9942 4.57245 30.9336 4.91705C26.8729 5.26166 23.8604 8.83284 24.205 12.8935C24.4658 15.967 26.5751 18.44 29.3461 19.3113L30.791 36.3384L34.0976 38.3094L36.3688 35.865L35.3768 33.5995L35.9708 31.1746L34.7223 29.551L35.6731 27.6671L34.3399 25.0443L35.1747 21.7939L34.2818 20.6965L34.5108 19.0339ZM33.095 9.17438C33.1787 10.1615 32.4464 11.0296 31.4593 11.1134C30.4722 11.1971 29.6041 10.4648 29.5203 9.47774C29.4366 8.49063 30.1689 7.62251 31.156 7.53874C32.1431 7.45497 33.0112 8.18727 33.095 9.17438Z"
        fill="#D1D1D1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.6973 19.1941C36.5157 17.9639 38.371 15.0401 38.0965 11.8057C37.7519 7.74507 34.1808 4.7326 30.1201 5.07721C26.0594 5.42181 23.0469 8.993 23.3915 13.0537C23.6524 16.1272 25.7617 18.6002 28.5326 19.4715L29.9776 36.4985L33.2841 38.4696L35.5553 36.0252L34.5633 33.7596L35.1573 31.3348L33.9088 29.7112L34.8596 27.8273L33.5264 25.2044L34.3612 21.9541L33.4683 20.8566L33.6973 19.1941ZM32.2815 9.33454C32.3653 10.3216 31.633 11.1898 30.6458 11.2735C29.6587 11.3573 28.7906 10.625 28.7068 9.6379C28.6231 8.65079 29.3554 7.78267 30.3425 7.6989C31.3296 7.61513 32.1977 8.34743 32.2815 9.33454Z"
        fill="white"
      />
      <rect
        x="30.4922"
        y="20.1895"
        width="0.709625"
        height="15.2184"
        transform="rotate(-4.01772 30.4922 20.1895)"
        fill="#D1D1D1"
      />
    </g>
  </svg>
)
